import { Circle, GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  AiOutlineHeart,
  AiOutlineProduct,
  AiOutlineUser,
} from "react-icons/ai";
import {
  FaBox,
  FaCoins,
  FaGlobe,
  FaHome,
  FaMapMarkerAlt,
  FaSignOutAlt,
  FaStar,
  FaUser,
} from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { FiLogIn, FiShoppingCart } from "react-icons/fi";
import { LuPhoneCall } from "react-icons/lu";
import { PiShoppingCartSimpleFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  AuthLogIn,
  AuthLogOut,
  AuthSignUp,
  Sociallogin,
} from "../../redux/slices/auth/authSlice";
import {
  getBusinessLocations,
  setSelectedBusinessLocations,
} from "../../redux/slices/businessLocation/businessLocationSlice";
import {
  getCart,
  removeFromCart,
  setCart,
  setCartItems,
  setSelectedCartItem,
} from "../../redux/slices/cart/cartSlice";
import { AuthChangePassword } from "../../redux/slices/changePassword/changePasswordSlice";
import { AuthForgotPassword } from "../../redux/slices/forgotPassword/forgotPasswordSlice";
import { AuthResetPassword } from "../../redux/slices/resetPassword/resetPasswordSlice";
import { setUser } from "../../redux/slices/user/userSlice";
import { RootState, store } from "../../redux/store";
import ChangePassword from "../ChangePassword/ChangePassword";
import CartSheet from "../common/CartSheet";
import Loader from "../common/Loader";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { DeliveryButton, SearchBar } from "../HomePage";
import Login from "../Login/Login";
import ResetPassword from "../ResetPassword/ResetPassword";
import { Modal } from "../shared/Modal";
import { Sheet } from "../shared/Sheet";
import SignUp from "../Signup/SignUp";
import HeaderTwoTitle from "./HeaderTwoTitle";
import { setFavLoggedIn } from "../../redux/slices/favorite/favoriteSlice";

interface NavItemProps {
  icon: React.ComponentType<{ size: number }>;
  text: string;
  className?: string;
}

const NavItem: React.FC<NavItemProps> = ({
  icon: Icon,
  text,
  className = "",
}) => (
  <div
    className={`flex items-center gap-2 px-3 py-1 text-gray-400 cursor-pointer ${className}`}
  >
    <Icon size={14} />
    <span className="text-xs">{text}</span>
  </div>
);

// Divider component
const Divider = () => <div className="h-4 w-px bg-[#E6E6E6] mx-2" />;

const Header = () => {
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isSignUpForm, setSignUpForm] = useState(false);
  const businessLocationId = useSelector(
    (state: any) => state.businessLocationId
  );
  const [incorrectCreds, setIncorrectCreds] = useState(false);
  const [expand, setExpand] = useState<
    { id: number; expanded: boolean } | undefined
  >(undefined);
  const [isChangePasswordForm, setChangePasswordForm] = useState(false);
  const [isForgotPasswordForm, setForgotPasswordForm] = useState(false);
  const [isResetPasswordForm, setResetPasswordForm] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showSignOutDialog, setShowSignOutDialog] = useState(false);
  const [businesLocationOpen, setBusinessLocationOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);
  const profileDropdownRef = useRef<HTMLDivElement>(null); // Ref to handle click outside
  const [showMap, setShowMap] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const { auth } = useSelector((state: RootState) => state.auth);
  const { user } = useSelector((state: RootState) => state.user);
  const pathname = useLocation().pathname;
  const { cart, isLoggedin, selectedCartItem, cartItems } = useSelector(
    (state: RootState) => state.cart
  );
  const { selectedFavorite, isFavLoggedin, favListLoggedin } = useSelector(
    (state: RootState) => state.favorite
  );

  let cartTotal = 0;
  cartTotal = cartItems?.reduce(
    (acc: number, item: any) =>
      acc +
      (item.branchProductListResponse?.sellingPriceWithTax || 0) *
        (item.quantity || 0),
    0
  );

  const { businessLocations, selectedBusinessLocation, isLoading } =
    useSelector((state: RootState) => state.businessLocation);
  const radiusInMeters = 1500;
  const { dispatch } = store;

  const navigate = useNavigate();

  const confirmRemove = () => {
    if (selectedItem) {
      dispatch(removeFromCart([selectedItem?.id]));
    }
    setRemoveOpen(false);
    setSelectedItem(null);
  };

  const toggleLoginModal = () => {
    setLoginModalOpen(!isLoginModalOpen);
    setSignUpForm(false);
    setChangePasswordForm(false);
    setForgotPasswordForm(false);
    setResetPasswordForm(false);
  };

  const handleSignOut = async () => {
    await dispatch(AuthLogOut());
    localStorage.removeItem("authToken");
    setLoginModalOpen(false);
    setShowProfileDropdown(false);
    setShowSignOutDialog(false);
    dispatch(setCart([]));
    dispatch(setCartItems([]));
    dispatch(setUser(null));
    navigate("/");
  };

  // Submit handlers
  const handleLoginSubmit = (
    values: any,
    actions: any,
    selectedCartItem?: any
  ) => {
    actions.setSubmitting(true);
    dispatch(AuthLogIn(values, selectedCartItem, selectedFavorite))
      .then((res) => {
        if (res.success) {
          actions.setSubmitting(false);
          setLoginModalOpen(false);
          setIncorrectCreds(false);
          dispatch(setFavLoggedIn(false));
        } else {
          actions.setSubmitting(false);
          setIncorrectCreds(true);
        }
      })
      .catch((error) => {
        actions.setSubmitting(false);
        console.error("Login failed:", error);
      });
  };

  const handleRemoveClick = (item: any) => {
    setSelectedItem(item);
    setRemoveOpen(true);
  };

  const handleSignUpSubmit = (values: any, actions: any) => {
    actions.setSubmitting(true);
    dispatch(AuthSignUp(values))
      .then(() => {
        actions.setSubmitting(false);
        setSignUpForm(false);
        setLoginModalOpen(false);
      })
      .catch((error) => {
        actions.setSubmitting(false);
        console.error("SignUp failed:", error);
      });
  };

  const handleChangePasswordSubmit = (values: any, actions: any) => {
    actions.setSubmitting(true);
    dispatch(AuthChangePassword(values))
      .then(() => {
        actions.setSubmitting(false);
        setLoginModalOpen(false);
      })
      .catch((error) => {
        actions.setSubmitting(false);
        console.error("Change Password failed:", error);
      });
  };

  const handleForgotPasswordSubmit = (values: any, actions: any) => {
    actions.setSubmitting(true);
    dispatch(AuthForgotPassword(values))
      .then((res) => {
        console.log("🚀 ~ .then ~ res:", res);
        if (res?.success) {
          actions.setSubmitting(false);
          setForgotPasswordForm(false);
          setResetPasswordForm(true);
          setIncorrectCreds(false);
        } else {
          actions.setSubmitting(false);
          setIncorrectCreds(true);
        }
      })
      .catch((error) => {
        actions.setSubmitting(false);
        console.error("Forgot password failed:", error);
      });
  };
  const handleResetPasswordSubmit = (values: any, actions: any) => {
    actions.setSubmitting(true);
    dispatch(AuthResetPassword(values))
      .then(() => {
        actions.setSubmitting(false);
        setResetPasswordForm(false);
      })
      .catch((error) => {
        actions.setSubmitting(false);
        console.error("Reset password failed:", error);
      });
  };

  const handleSignIInDialog = (value: boolean) => {
    setLoginModalOpen(value);
    setSignUpForm(false);
    setChangePasswordForm(false);
    setForgotPasswordForm(false);
    setResetPasswordForm(false);
    if (!value) {
      dispatch(setSelectedCartItem(null));
    }
    if (!value) {
      dispatch(setFavLoggedIn(false));
    }
  };
  const handleSocialLogin = async (values: any) => {
    try {
      dispatch(
        Sociallogin({
          authProvider: "GOOGLE",
          token: values.credential,
        })
      );
    } catch (error) {
      console.error("Social login failed:", error);
    }
  };

  useEffect(() => {
    dispatch(getBusinessLocations());
    if (user && selectedBusinessLocation) {
      dispatch(getCart(user.id, selectedBusinessLocation.id));
    }
  }, [user, selectedBusinessLocation]);

  useMemo(() => {
    // console.log(isLoggedin);
    if (selectedCartItem) {
      if (!isLoggedin) {
        setLoginModalOpen(true);
      }
    }
    if (selectedFavorite) {
      if (!isFavLoggedin) {
        setLoginModalOpen(true);
      }
    }
    if (favListLoggedin) {
      console.log("🚀 ~ useMemo ~ favListLoggedin:", favListLoggedin);
      setLoginModalOpen(true);
    }
  }, [selectedCartItem, selectedFavorite, favListLoggedin]);

  useEffect(() => {
    if (!selectedBusinessLocation) {
      setBusinessLocationOpen(true);
    }
  }, [selectedBusinessLocation]);
  return (
    <div className="flex flex-col divide-y divide-gray-200">
      <div className="w-full py-1 hidden justify-center lg:flex items-center px-4 bg-white">
        <div className="flex items-center justify-between w-full max-w-[1150px]">
          <div className="flex gap-1 items-center text-xs text-white">
            <div
              onClick={() => setBusinessLocationOpen(true)}
              className="flex items-center gap-1 cursor-pointer text-gray-400"
            >
              <div>
                <FaMapMarkerAlt />
              </div>
              <span>Store Location :</span>
              <span className="">
                {selectedBusinessLocation?.businessName ?? "Delivery Location"}
              </span>
            </div>
          </div>

          <div className="flex items-center text-gray-400">
            <NavItem
              icon={FaCoins}
              text="POUNDS(£)"
              className="text-[#666666] text-[12px] leading-[12px]"
            />
            <Divider />
            <NavItem
              icon={FaGlobe}
              text="ENGLISH"
              className="text-[#666666] text-[12px] leading-[12px]"
            />
            <Divider />
            <div className="hidden lg:flex items-center gap-3 lg:gap-6 ml-auto relative">
              {/* Conditionally Render Login or User Icon */}
              {user ? (
                <div
                  ref={profileDropdownRef}
                  className="flex items-center transition-all duration-500 hover:text-gray-300 gap-2 cursor-pointer"
                  onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                >
                  <AiOutlineUser size={20} color="#05A30D" />
                  <span className="text-sm text-nowrap font-semibold">
                    {user.firstName}
                  </span>
                </div>
              ) : (
                <button
                  onClick={toggleLoginModal}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  {/* <AiOutlineUser size={30} color="#05A30D" /> */}
                  <span className=" text-[#666666] text-[12px] leading-[12px]">
                    Sign In / Sign Up
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="min-h-[82px] w-full lg:pt-3 lg:px-[32px] flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-center">
        <div className="flex flex-col lg:flex-row gap-3 lg:gap-12 max-w-[1150px] w-full lg:items-center">
          <HeaderTwoTitle />

          <div className="flex py-2 px-3 lg:flex-row lg:justify-center flex-col mb-2 items-stretch gap-2 lg:gap-6 flex-grow">
            <DeliveryButton
              setLocationsOpen={setBusinessLocationOpen}
              setLoginModal={setLoginModalOpen}
            />
            <SearchBar />
          </div>
          <div className="flex items-center divide-x gap-2">
            <div>
              <Link
                to="/favorite"
                className="flex items-center w-full px-4 py-2 text-sm text-gray-700"
              >
                <AiOutlineHeart
                  size={30}
                  className="hidden lg:block"
                  strokeWidth="25"
                  color="#05A30D"
                />
              </Link>
            </div>
            <div
              onClick={() => setCartOpen(true)}
              className="relative transition-all gap-2 hidden lg:flex cursor-pointer hover:scale-110  items-center w-full px-4 py-2 text-sm text-gray-700 duration-500"
            >
              <div className="relative flex">
                {cart.length > 0 && (
                  <div className="absolute top-0 -right-1 flex bg-red-500 text-white rounded-full text-xs font-semibold w-[18px] h-[18px]  items-center justify-center">
                    {cart.length}
                  </div>
                )}
                <FiShoppingCart
                  size={30}
                  className="hidden lg:block"
                  color="#05A30D"
                />
              </div>
              <div className="flex flex-col">
                <div className="text-gray-400 text-[8px]">Shopping cart :</div>
                <div className="relative text-xs font-[600]">
                  £{cartTotal > 0 ? cartTotal.toFixed(2) : "0.00"}
                </div>
              </div>
            </div>
          </div>
        </div>

        {showSignOutDialog && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1003]">
            <div className="bg-white rounded-lg p-6 max-w-sm w-full mx-4">
              <h2 className="text-xl font-semibold mb-4">Sign Out</h2>
              <p className="text-gray-600 mb-6">
                Are you sure you want to sign out? You'll need to sign in again
                to access your account.
              </p>
              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setShowSignOutDialog(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSignOut}
                  className="px-4 py-2 text-sm font-medium text-red-600 bg-red-100 hover:bg-red-200 rounded-md"
                >
                  Sign Out
                </button>
              </div>
            </div>
          </div>
        )}

        {removeOpen && (
          <Modal
            isOpen={removeOpen}
            setISOpen={setRemoveOpen}
            title="Remove item from cart?"
            content={
              <div className="w-full flex flex-col gap-3 px-3 items-center">
                <div className="text-center w-full font-medium">
                  Are you sure you want to remove this item from the cart?
                </div>
                <div className="flex w-full gap-3 py-2 justify-center items-center">
                  <div
                    className="w-32 cursor-pointer text-black font-semibold  transition-all hover:opacity-70 content-center text-center bg-[#C9CCC9] rounded-full h-10"
                    onClick={confirmRemove}
                  >
                    Yes
                  </div>
                  <div
                    className="w-32 cursor-pointer text-white transition-all hover:opacity-70 font-semibold content-center text-center bg-[#05A30D] rounded-full h-10"
                    onClick={() => setRemoveOpen(false)}
                  >
                    Cancel
                  </div>
                </div>
              </div>
            }
          />
        )}

        <Sheet
          isOpen={cartOpen}
          onClose={() => setCartOpen(false)}
          direction="right"
          children={
            <CartSheet
              removeOpen={removeOpen}
              setRemoveOpen={setRemoveOpen}
              handleRemoveClick={handleRemoveClick}
            />
          }
        />

        <Sheet
          direction="right"
          isOpen={showProfileDropdown}
          onClose={() => setShowProfileDropdown(false)}
          children={
            <div className="w-full mt-5 flex h-full relative flex-col gap-3 py-1">
              {auth ? (
                <>
                  <Link
                    to="/profile"
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <FaUser size={20} className=" basis-[15%] mr-2" />
                    My Profile
                  </Link>

                  <Link
                    to="/cart"
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <div className="relative flex justify-center basis-[15%] mr-2">
                      {cart.length > 0 && (
                        <div className="absolute top-0 right-2 bg-red-500 text-white rounded-full text-xs font-semibold w-4 h-4 flex items-center justify-center">
                          {cart.length}
                        </div>
                      )}
                      <PiShoppingCartSimpleFill size={24} className="" />
                    </div>
                    My cart
                  </Link>

                  <Link
                    to="/order"
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <FaBox size={17} className="mr-2 basis-[15%]" />
                    My Orders
                  </Link>

                  <Link
                    to="/reviews"
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <FaStar size={20} className="mr-2 basis-[15%]" />
                    My Reviews
                  </Link>

                  <button
                    onClick={() => setShowSignOutDialog(true)}
                    className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                  >
                    <FaSignOutAlt className="mr-2 basis-[15%]" />
                    Sign Out
                  </button>
                </>
              ) : (
                <div
                  onClick={() => setLoginModalOpen(true)}
                  className="flex items-center w-full px-4 py-2 text-md text-gray-700 hover:bg-gray-100"
                >
                  <FiLogIn className="mr-2 basis-[15%]" size={28} />
                  Login
                </div>
              )}
            </div>
          }
        />
        <Sheet
          isOpen={businesLocationOpen}
          onClose={() => setBusinessLocationOpen(false)}
          direction="right"
          closeColor="text-white"
          children={
            <div className="flex flex-col">
              <div className="w-full px-2 text-white bg-[#333333] py-3 font-semibold">
                Please Select a Business Location
              </div>
              {isLoading ? (
                <div className="w-full col-span-2 justify-center flex items-center py-5">
                  <Loader />
                </div>
              ) : (
                <div className="flex flex-col gap-2 px-2 py-3">
                  {businessLocations?.map((location: any) => (
                    <div
                      key={location.id}
                      onClick={() =>
                        setExpand({
                          id: location.id,
                          expanded: true,
                        })
                      }
                      className={`flex items-start justify-center flex-col border-[1px] px-2 py-2 ${
                        selectedBusinessLocation?.id === location.id
                          ? "bg-[#05A30D] text-white"
                          : "bg-white hover:bg-gray-200 hover:shadow-custom hover:shadow-[#05A30D] hover:text-black"
                      } rounded-md cursor-pointer shadow-custom`}
                    >
                      <div className="font-semibold text-md pb-1">
                        {location.businessName}
                      </div>
                      <div
                        className={`text-xs ${
                          selectedBusinessLocation?.id !== location.id &&
                          "text-gray-600"
                        }`}
                      >
                        {location.description}
                      </div>
                      <div
                        className={`text-xs ${
                          selectedBusinessLocation?.id !== location.id &&
                          "text-gray-600"
                        }`}
                      >
                        {location.city}
                      </div>
                      {expand?.id === location.id && expand?.expanded && (
                        <div className="w-full mt-2">
                          <LoadScript
                            googleMapsApiKey={
                              process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""
                            }
                          >
                            <GoogleMap
                              mapContainerStyle={{
                                width: "100%",
                                height: "250px",
                              }}
                              center={{
                                lat: location.latitude,
                                lng: location.longitude,
                              }}
                              zoom={12}
                              options={{
                                disableDefaultUI: false,
                                zoomControl: true,
                              }}
                            >
                              <Marker
                                position={{
                                  lat: location.latitude,
                                  lng: location.longitude,
                                }}
                                icon={{
                                  url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                                }}
                              />
                              <Circle
                                center={{
                                  lat: location.latitude,
                                  lng: location.longitude,
                                }}
                                radius={radiusInMeters}
                                options={{
                                  fillColor: "red",
                                  fillOpacity: 0.1,
                                  strokeColor: "red",
                                  strokeOpacity: 0.6,
                                  strokeWeight: 2,
                                }}
                              />
                            </GoogleMap>
                          </LoadScript>
                          <div className="mt-3 flex justify-end">
                            <button
                              onClick={() => {
                                dispatch(
                                  setSelectedBusinessLocations(location)
                                );
                                setExpand(undefined);
                                setBusinessLocationOpen(false);
                              }}
                              className="px-4 py-2 bg-[#05A30D] text-white rounded-md hover:bg-green-700"
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          }
        />
      </div>
      {/* Modal */}
      <Modal
        title={
          isSignUpForm
            ? "Sign Up"
            : isChangePasswordForm
            ? "Change Password"
            : isForgotPasswordForm
            ? "Forgot Password"
            : isResetPasswordForm
            ? "Reset Password"
            : "Login"
        }
        isOpen={isLoginModalOpen}
        setISOpen={handleSignIInDialog}
        content={
          isSignUpForm ? (
            <SignUp
              onSubmit={handleSignUpSubmit}
              toggleForm={() => setSignUpForm(false)}
            />
          ) : isChangePasswordForm ? (
            <ChangePassword
              onSubmit={handleChangePasswordSubmit}
              toggleForm={() => setChangePasswordForm(false)}
            />
          ) : isForgotPasswordForm ? (
            <ForgotPassword
              onSubmit={(values, actions) => {
                actions.setSubmitting(true);
                handleForgotPasswordSubmit(values, actions);
              }}
              toggleForm={() => setForgotPasswordForm(false)}
              setIncorrectCreds={setIncorrectCreds}
              incorrectCreds={incorrectCreds}
            />
          ) : isResetPasswordForm ? (
            <ResetPassword
              onSubmit={handleResetPasswordSubmit}
              toggleForm={() => setResetPasswordForm(false)}
            />
          ) : (
            <Login
              setIncorrectCreds={setIncorrectCreds}
              incorrectCreds={incorrectCreds}
              onSubmit={handleLoginSubmit}
              setSignUpForm={setSignUpForm}
              setChangePasswordForm={setChangePasswordForm}
              setForgotPasswordForm={setForgotPasswordForm}
              setResetPasswordForm={setResetPasswordForm}
              onSocialLogin={handleSocialLogin}
              selectedCartItem={selectedCartItem}
            />
          )
        }
      />

      {/* Desktop Header */}
      <div className="w-full h-12 hidden md:flex justify-center items-center bg-[#333333]">
        <div className="max-w-[1150px] w-[1150px] px-3 h-full flex items-center justify-between">
          <div className="flex gap-5  py-1 font-[520] justify-evenly">
            <div
              onClick={() => navigate("/")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/" && "text-white"
              } hover:text-white`}
            >
              Home
            </div>
            <div
              onClick={() => navigate("/products")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/products" && "text-white"
              } hover:text-white`}
            >
              Products
            </div>
            <div
              onClick={() => navigate("/aboutus")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/aboutus" && "text-white"
              } hover:text-white`}
            >
              About Us
            </div>
            <div
              onClick={() => navigate("/contactus")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/contact" && "text-white"
              } hover:text-white`}
            >
              Contact us
            </div>
          </div>
          <div className="flex gap-2 items-center font-[520] text-sm justify-center text-gray-400">
            <LuPhoneCall className="size-6" />
            <a href="tel:+441233754241" className="">
              +44 1233 754241
            </a>
          </div>
        </div>
      </div>

      {/* Mobile nav bar */}
      <div className="w-full h-12 md:hidden flex justify-center items-center bg-[#333333]">
        <div className="max-w-[1150px] w-[1150px] px-3 h-full flex items-center justify-between">
          <div className="flex gap-5  py-1 font-[520] justify-evenly w-full">
            <div
              onClick={() => navigate("/")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/" && "text-white"
              } hover:text-white`}
            >
              <FaHome size={20} />
            </div>
            <div
              onClick={() => navigate("/products")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/products" && "text-white"
              } hover:text-white`}
            >
              <AiOutlineProduct size={20} />
            </div>
            <div
              onClick={() => navigate("/aboutus")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/aboutus" && "text-white"
              } hover:text-white`}
            >
              <FaUsers size={20} />
            </div>
            <div
              onClick={() => navigate("/contact")}
              className={`text-gray-400 transition-all cursor-pointer flex items-center justify-center text-sm text-center px-2 hover:scale-105 ${
                pathname === "/contact" && "text-white"
              } hover:text-white`}
            >
              <LuPhoneCall size={20} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
